import React from "react";
import { useLanguage } from "../Router/LanguageContext";

export default function Faq() {
  const { dictionary } = useLanguage();

  const faqData = [
    {
      id: 1,
      question: dictionary?.faq1Question,
      answer: dictionary?.faq1Answer,
    },
    {
      id: 2,
      question: dictionary?.faq2Question,
      answer: dictionary?.faq2Answer,
    },
    {
      id: 3,
      question: dictionary?.faq3Question,
      answer: dictionary?.faq3Answer,
    },
    {
      id: 4,
      question: dictionary?.faq4Question,
      answer: dictionary?.faq4Answer,
    },
    {
      id: 5,
      question: dictionary?.faq5Question,
      answer: dictionary?.faq5Answer,
    },
  ];
  return (
    <div className="container-fluid maxContainerSection commonPadding">
      <div className="row">
        <div className="col-md-12 whowearehedaersection ourSolutionSectionHeader">
          <h2 className="m-0 f-s-48">{dictionary?.faqTitle}</h2>
          <p className="m-0 f-s-20 ">{dictionary?.faqDescription}</p>
        </div>
      </div>

      <div className="row faqSectionClass">
        {/* Left Image */}
        <div className="col-md-6">
          <img
            className="faqImage img-fluid"
            src="/assets/img/img-faq.jpeg"
            alt="Factory"
          />
        </div>

        {/* Right Accordion */}
        <div className="col-md-6 accordionMainSection">
          <div className="accordion custom-accordion" id="faqAccordion">
            {faqData.map((item, index) => (
              <div className="accordion-item" key={item.id}>
                <h2 className="accordion-header">
                  <button
                    className={`accordion-button collapsed f-w-600 f-s-20`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse${item.id}`}
                    aria-expanded={index === 1 ? "true" : "false"}
                    aria-controls={`collapse${item.id}`}
                  >
                    {item.question}
                  </button>
                </h2>

                <div
                  id={`collapse${item.id}`}
                  className={`accordion-collapse collapse`}
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body f-s-16">{item.answer}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
